module.exports = __webpack_public_path__ + "static/img/kk1.412d946.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/thumbnails/kk1.jpg
// module id = 626
// module chunks = 0